import React, { Dispatch, SetStateAction, useMemo, useState } from 'react'

import { credentialsFields } from './credentialsFields'
import { Button, ConfirmationModal, SectionSubtitle } from '../..'
import { useProfileForm, useUser } from '../../../context'
import { Spacer } from '../../global'
import SectionFields from '../DynamicFields/SectionFields'

const CredentialsSection = ({
  showCredentials,
  setShowCredentials,
}: {
  showCredentials: boolean
  setShowCredentials: Dispatch<SetStateAction<boolean>>
}) => {
  const { onEditionMode } = useUser()
  const { values, formActions, isNewUser, credentials, saveCredentials } =
    useProfileForm()

  const [showModal, setShowModal] = useState(false)

  const isDisabled = isNewUser ? isNewUser : onEditionMode

  const fields = useMemo(
    () =>
      credentialsFields({
        state: isNewUser ? values : credentials,
        isNewUser,
      }),
    [values, credentials],
  )

  const isChangingPassword =
    credentials.password !== '' && credentials.confirmPassword !== ''
  const isChangingEmail =
    credentials.email !== '' && credentials.confirmEmail !== ''

  const disabledButton =
    credentials.currentPassword === '' ||
    credentials.currentEmail === '' ||
    (isChangingPassword &&
      (credentials.password === '' ||
        credentials.confirmPassword === '' ||
        credentials.password !== credentials.confirmPassword)) ||
    (isChangingEmail &&
      (credentials.email === '' ||
        credentials.confirmEmail === '' ||
        credentials.email !== credentials.confirmEmail)) ||
    (!isChangingPassword && !isChangingEmail)
      ? true
      : false

  return (
    <>
      {showModal && (
        <ConfirmationModal
          message="Seguro quieres cambiar las credenciales"
          handleModalClose={() => setShowModal(false)}
          continueFn={() => saveCredentials(setShowModal)}
        />
      )}

      {(showCredentials || isNewUser) && (
        <>
          <Spacer height={30} />
          <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
            Credenciales de acceso
          </SectionSubtitle>
          <SectionFields
            fields={fields}
            formActions={formActions}
            isDisabled={isDisabled}
          />
          {!isNewUser && (
            <div className="d-flex justify-content-center">
              {!isChangingPassword && !isChangingEmail ? (
                <Button
                  className="dark-grey"
                  onClick={() => setShowCredentials(false)}
                  label="Cerrar credenciales"
                  fontSize={16}
                />
              ) : (
                <Button
                  className="dark-grey"
                  onClick={() => setShowModal(true)}
                  disabled={disabledButton}
                  label="Actualizar credenciales"
                  fontSize={16}
                />
              )}
            </div>
          )}
        </>
      )}
    </>
  )
}

export default CredentialsSection
